export const PREGUNTA_ELECCION = '¿Qué querés hacer ahora?';

const porOrden = (a, b) => (a.orden ?? 0) - (b.orden ?? 0);

const pasosDe = (onboarding) => [...(onboarding?.pasos || [])].sort(porOrden);

export const accionesPendientes = (onboarding) => pasosDe(onboarding).filter((p) => !p.completo);

export const accionesHechas = (onboarding) => pasosDe(onboarding).filter((p) => p.completo);

// Tocar una acción manda su título como mensaje: es el texto exacto que el servidor reconoce como elección.
export const chipsDeAcciones = (pendientes = []) => pendientes.map((p) => ({ id: p.clave, label: p.titulo, mensaje: p.titulo }));

// Una acción a la vez: mientras la elegida siga pendiente no se ofrecen las otras.
export const accionEnCursoVigente = (enCurso, pendientes = []) => (enCurso && pendientes.some((p) => p.clave === enCurso) ? enCurso : null);

export const accionesAOfrecer = (onboarding, enCurso) => {
  const pendientes = accionesPendientes(onboarding);
  return accionEnCursoVigente(enCurso, pendientes) ? [] : pendientes;
};

// Misma lista que el servidor usa para soltar la acción en curso.
const SALIDAS_DE_ACCION = ['cancelar', 'cancelo', 'cancelalo', 'otra cosa', 'salir', 'volver', 'dejalo'];

export const normalizar = (t) => String(t || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9ñ ]/g, ' ').replace(/\s+/g, ' ').trim();

export const esSalidaDeAccion = (texto) => SALIDAS_DE_ACCION.includes(normalizar(texto));

// La pregunta de elección no depende del historial: se ofrece mientras haya acciones pendientes y nada en curso.
export const preguntaEleccionVisible = ({ onboarding, enCurso, awaitingConfirm = false, isSending = false } = {}) =>
  onboarding?.activo === true && !awaitingConfirm && !isSending && accionesAOfrecer(onboarding, enCurso).length > 0;

export const progresoRecorrido = (onboarding) => {
  const pasos = pasosDe(onboarding);
  if (pasos.length === 0) return null;
  const hechos = pasos.filter((p) => p.completo).length;
  return { hechos, total: pasos.length, texto: `${hechos} de ${pasos.length}` };
};

// Sin estado previo (primera lectura) no hay transición: no se felicita por lo que ya estaba hecho.
export const pasosRecienCompletos = (previo, actual) => {
  if (!previo?.pasos) return [];
  const estabaCompleto = new Map(previo.pasos.map((p) => [p.clave, !!p.completo]));
  return pasosDe(actual).filter((p) => p.completo && estabaCompleto.get(p.clave) === false);
};

export const FRASE_RECORRIDO_COMPLETO = 'Ya hiciste todo lo del recorrido inicial. Si necesitás algo más, escribime.';

const frase = (completos) => completos.map((p) => `«${p.titulo}»`).join(' y ');

export const mensajeListo = (completos, restantes) => {
  const hecho = `Listo ✓ ${frase(completos)} quedó hecho.`;
  return restantes.length > 0 ? hecho : `${hecho} ${FRASE_RECORRIDO_COMPLETO}`;
};

export const avisoDeTransicion = (previo, actual) => {
  const completos = pasosRecienCompletos(previo, actual);
  if (completos.length === 0) return null;
  return { texto: mensajeListo(completos, accionesPendientes(actual)), claves: completos.map((p) => p.clave) };
};
